<span
  class="flex-auto items-center tc normal body mv3 mh0 heading-copy-typeface"
>
  <ng-content></ng-content>
</span>
